import { Link } from "react-router-dom";

import "../../utilities.css";
import "./NavBarDropdown.css";

function NavBarDropdown (props) {
  return (
    <> 
      <ul className="navbardropdown-menu">
        {props.menuItems.map((item, index) => {
          return (
            <li key={index}> 
              {
                item.localpath ? (
                    <Link 
                      className="navbardropdown-link" 
                      to={item.path} 
                      onClick={props.onItemClick}
                    > 
                      {item.title} 
                    </Link>
                  ) : (
                    <a 
                      className="navbardropdown-link" 
                      href={item.path} 
                      onClick={props.onItemClick}
                    > 
                      {item.title} 
                    </a>
                  )
              }
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default NavBarDropdown
